import { atom } from "recoil"

const hideDrawerMenuState = atom({
  key: 'hideDrawerMenuState',
  default: false,
});

export default hideDrawerMenuState;
